var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthenticator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53227"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 .003h24v24H0z",
    "data-name": "Rectangle 16764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.963 15.275 7.908 12.22l1.527-1.527 1.527 1.527 3.873-3.873 1.528 1.527ZM6.545 24a2.1 2.1 0 0 1-1.541-.641 2.1 2.1 0 0 1-.641-1.541V2.179A2.1 2.1 0 0 1 5.004.638a2.1 2.1 0 0 1 1.541-.641h10.91a2.1 2.1 0 0 1 1.541.641 2.1 2.1 0 0 1 .641 1.541v19.639a2.1 2.1 0 0 1-.641 1.541 2.1 2.1 0 0 1-1.541.641Zm0-3.273v1.091h10.91v-1.091Zm0-2.182h10.91V5.453H6.545Zm0-15.275h10.91V2.179H6.545Zm0 0Zm0 17.457Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticator);
export default __webpack_public_path__ + "static/media/authenticator.ac6a5b48d8c0fc50f8b837f233eb4960.svg";
export { ForwardRef as ReactComponent };